function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "icon-copy");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon-copy",
  stroke: "none",
  strokeWidth: 1,
  fill: "#003C57",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.000000, 7.000000)",
  fill: "#003C57",
  fillRule: "nonzero",
  id: "Duplicate"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.238,15.45 L13.238,4.938 L5.012,4.938 L5.012,15.45 L13.238,15.45 Z M13.238,3.462 C13.646002,3.462 13.9999985,3.60599856 14.3,3.894 C14.6000015,4.18200144 14.75,4.52999796 14.75,4.938 L14.75,15.45 C14.75,15.858002 14.6000015,16.2119985 14.3,16.512 C13.9999985,16.8120015 13.646002,16.962 13.238,16.962 L5.012,16.962 C4.60399796,16.962 4.2500015,16.8120015 3.95,16.512 C3.6499985,16.2119985 3.5,15.858002 3.5,15.45 L3.5,4.938 C3.5,4.52999796 3.6499985,4.18200144 3.95,3.894 C4.2500015,3.60599856 4.60399796,3.462 5.012,3.462 L13.238,3.462 Z M10.988,0.438 L10.988,1.95 L1.988,1.95 L1.988,12.462 L0.512,12.462 L0.512,1.95 C0.512,1.54199796 0.65599856,1.1880015 0.944,0.888 C1.23200144,0.5879985 1.57999796,0.438 1.988,0.438 L10.988,0.438 Z"
})));

function SvgIconCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "6caf1070c76c2e3c5d354027e7b52f14.svg";
export { SvgIconCopy as ReactComponent };